import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OnboardingGuard } from './guards/onboarding.guard';
import { MywalletGuard } from './guards/mywallet.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./pages/onboarding/onboarding.module').then( m => m.OnboardingPageModule),
    canActivate: [OnboardingGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'puntos-verdes',
    loadChildren: () => import('./pages/puntos-verdes/puntos-verdes.module').then( m => m.PuntosVerdesPageModule)
  },
  {
    path: 'centro-canje',
    loadChildren: () => import('./pages/centro-canje/centro-canje.module').then( m => m.CentroCanjePageModule)
  },
  {
    path: 'servicio-retiro',
    loadChildren: () => import('./pages/servicio-retiro/servicio-retiro.module').then( m => m.ServicioRetiroPageModule)
  },
  {
    path: 'estadisticas',
    loadChildren: () => import('./pages/estadisticas/estadisticas.module').then( m => m.EstadisticasPageModule)
  },
  {
    path: 'mi-cuenta',
    loadChildren: () => import('./pages/mi-cuenta/mi-cuenta.module').then( m => m.MiCuentaPageModule)
  },
  {
    path: 'contacto',
    loadChildren: () => import('./pages/contacto/contacto.module').then( m => m.ContactoPageModule)
  },
  {
    path: 'mywallet',
    loadChildren: () => import('./pages/mywallet/mywallet.module').then( m => m.MywalletPageModule),
    canActivate: [MywalletGuard]
  },
  {
    path: 'reciclados',
    loadChildren: () => import('./pages/reciclados/reciclados.module').then( m => m.RecicladosPageModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
